export default {
   methods: {
      storeWindowWidth() {
         const w = window.getComputedStyle(document.body).width;
         document.body.style.width = w;
         const header = document.querySelector('.header');
         if (header) {
            header.style.right = 'auto';
            header.style.width = w;
         }
      },

      restoreWindowWidth() {
         document.body.style.width = '';
         const header = document.querySelector('.header');
         if (header) {
            header.style.width = '';
            header.style.right = '';
         }
      }
   }
};
